import { render, staticRenderFns } from "./ParameterDetailStep.vue?vue&type=template&id=de97630a&scoped=true&"
import script from "./ParameterDetailStep.vue?vue&type=script&lang=js&"
export * from "./ParameterDetailStep.vue?vue&type=script&lang=js&"
import style0 from "./ParameterDetailStep.vue?vue&type=style&index=0&id=de97630a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de97630a",
  null
  
)

export default component.exports